import { ComponentPropsWithoutRef } from 'react';
import { Collapsible, OmitStrict } from '@tanium/coreui-utils';
import styled from '@tanium/react-emotion-9';
import { CaretDownIcon, Icon } from '@tanium/react-graphics';
import { color, colorStylePropNames, ColorStyleProps } from '@tanium/style-system';

export interface Props
  extends OmitStrict<ComponentPropsWithoutRef<Icon>, 'color' | 'opacity'>,
    ColorStyleProps,
    Collapsible {}

export const Disclosure = styled(CaretDownIcon, {
  shouldForwardProp: (prop) => ['isCollapsed', ...colorStylePropNames].indexOf(prop) === -1,
})<Props>(color, ({ isCollapsed }) => ({
  transform: isCollapsed ? 'rotate(-90deg)' : undefined,
}));

Disclosure.defaultProps = {
  height: 8,
  width: 8,
};
